module.exports = __webpack_public_path__ + "img/broken-heart.86f80393.svg";